import { Outlet } from '@tanstack/react-router';
import MainLayout from '@ui/components/templates/main-layout/main-layout.template';
import useMainViewModel from './main.view-model';

export default function MainView() {
  // #region Dependencies
  const { errorDialog, loading } = useMainViewModel();
  // #endregion

  return (
    <MainLayout errorDialog={errorDialog} hasSuspense isLoading={loading}>
      <Outlet />
    </MainLayout>
  );
}
